const STORAGE_KEY = 'dealzy_cookie_consent';

export function getCookieConsent() {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
}

export function setCookieConsent() {
    try {
        localStorage.setItem(STORAGE_KEY, 'true');
    } catch { /* localStorage unavailable or full - ignore */ }
}
